import { render, staticRenderFns } from "./set.vue?vue&type=template&id=571bbce0&scoped=true&"
import script from "./set.vue?vue&type=script&lang=js&"
export * from "./set.vue?vue&type=script&lang=js&"
import style0 from "./set.vue?vue&type=style&index=0&id=571bbce0&prod&lang=scss&"
import style1 from "./set.vue?vue&type=style&index=1&id=571bbce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bbce0",
  null
  
)

export default component.exports